import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../configuration';
import { getBankAccount, updateBankAccount } from '../../../api/admin/user.api';
import toast from 'react-hot-toast';
import { InputWarning } from '../../../components/inputwarning/input-warning.component';

const Wallet = () => {
  const profile = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const [bankName, setBankName] = useState('');
  const [bankAccountNumber, setBankAccountNumber] = useState('');
  const [bankAccountName, setBankAccountName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchBankAccount = async () => {
      try {
        const data = await getBankAccount();
        setBankName(data.bankName);
        setBankAccountNumber(data.bankAccountNumber);
        setBankAccountName(data.bankAccountName);
      } catch (error) {
        console.error('Error fetching bank account:', error);
      }
    };

    fetchBankAccount();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);
      await updateBankAccount({
        bankName,
        bankAccountNumber,
        bankAccountName,
      });
      toast.success('Cập nhật tài khoản ngân hàng thành công');
    } catch (error) {
      toast.error('Có lỗi xảy ra khi cập nhật tài khoản ngân hàng');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="relative flex flex-col border border-[#DEE0E6] dark:border-slate-700 min-w-0 break-words bg-white shadow-xl dark:bg-slate-850 dark:shadow-dark-xl rounded-2xl bg-clip-border ">
      <h2 className="text-[22px] leading-[26px] font-semibold dark:text-white p-3">
        Thông tin tài khoản ngân hàng
      </h2>

      <form onSubmit={handleSubmit}>
        <div className="p-3 bg-[#F6F7F8] flex flex-col space-y-4">
          <div>
            <label className=" flex items-center  text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Tên ngân hàng &nbsp;
              <InputWarning />
            </label>
            <input
              type="text"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
              className="mt-1 block w-full p-3 text-base rounded-lg bg-white dark:bg-slate-800 border border-gray-300 dark:border-gray-600 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-[#18191E] sm:text-sm dark:text-white"
              required
              placeholder="VD: SCB"
            />
          </div>

          <div>
            <label className=" flex items-center  text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Số tài khoản&nbsp;
              <InputWarning />
            </label>
            <input
              type="text"
              value={bankAccountNumber}
              onChange={(e) => setBankAccountNumber(e.target.value)}
              className="mt-1 block w-full p-3 text-base rounded-lg bg-white dark:bg-slate-800 border border-gray-300 dark:border-gray-600 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-[#18191E] sm:text-sm dark:text-white"
              required
              placeholder="Nhập số tài khoản ngân hàng"
            />
          </div>

          <div>
            <label className=" flex items-center  text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Tên chủ tài khoản&nbsp;
              <InputWarning />
            </label>
            <input
              type="text"
              value={bankAccountName}
              onChange={(e) => setBankAccountName(e.target.value)}
              className="mt-1 block w-full p-3 text-base rounded-lg bg-white dark:bg-slate-800 border border-gray-300 dark:border-gray-600 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-[#18191E] sm:text-sm dark:text-white"
              required
              placeholder="Nhập tên chủ tài khoản"
            />
          </div>
        </div>

        <div className="bg-white dark:bg-dark2 rounded-b-2xl p-3 ">
          <div className="bg-[#EBECF2] dark:bg-slate-700 p-2 rounded-lg w-full flex justify-end">
            <button
              type="submit"
              disabled={isSubmitting}
              className={`flex justify-center items-center h-8 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-[#0057FF] hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${
                isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isSubmitting
                ? 'Đang xử lý...'
                : bankName
                ? 'Cập nhật'
                : 'Thêm tài khoản'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Wallet;
